import * as Tabs from '@/components/ui/tabs'
import { Calculator, Pencil } from 'lucide-solid'
import { Show, onMount } from 'solid-js'
import { useService } from 'solid-services'
import { Box, Grid } from 'styled-system/jsx'
import Confirm from './Confirm'
import Details from './Details'
import Success from './Success'
import { FormSteps, useCreate } from './state'

export default function Create() {
  const { step, setStep } = useService(useCreate)()

  onMount(() => {
    setStep(FormSteps.details)
  })

  return (
    <Box w="full">
      {/* Show tabs only when we are NOT on the success/submission step */}
      <Show when={step() !== FormSteps.success}>
        <Tabs.Root
          colorPalette="jade"
          variant="subtle"
          lazyMount
          value={step()}
          fitted
          onValueChange={(e) => setStep(e.value as FormSteps)}
        >
          <Tabs.List justifyContent="space-between">
            <Tabs.Trigger
              textTransform="capitalize"
              value={FormSteps.details}
            >
              <Pencil />
              {FormSteps.details}
            </Tabs.Trigger>
            <Tabs.Trigger
              textTransform="capitalize"
              value={FormSteps.confirm}
            >
              <Calculator />
              {FormSteps.confirm}
            </Tabs.Trigger>
            <Tabs.Indicator />
          </Tabs.List>

          <Tabs.Content value={FormSteps.details}>
            <Details />
          </Tabs.Content>
          <Tabs.Content value={FormSteps.confirm}>
            <Confirm />
          </Tabs.Content>
        </Tabs.Root>
      </Show>

      {/* Render the Success component as an overlay/final view */}
      <Show when={step() === FormSteps.success}>
        <Success />
      </Show>
    </Box>
  )
}
